import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../src/AppContext";
import { Link } from "@material-ui/core";

import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import "../src/aboutStylesheet.css"
import Flip from 'react-reveal/Flip';

import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const obj=[ 


  [   
    "https://firebasestorage.googleapis.com/v0/b/tecmktg-363f7.appspot.com/o/BG%2Fprovideos.jpg?alt=media&token=71e7b16c-a246-40c2-8c68-2466e4f98279",
    [
        "Professional Videos",
        "Videos Profesionales"
    ],
    ""
        
  ],

  [   
    "https://firebasestorage.googleapis.com/v0/b/tecmktg-363f7.appspot.com/o/BG%2FFACEBOOK%20LIVE%20BANNER.jpg?alt=media&token=37c61208-964f-4d65-b49c-f8460d3694a6",
    [
        " ",
        " "
    ],
       "https://www.facebook.com/TecItalyNorthEast/live_videos/"  
  ],









]


const properties = {
  arrows: true,
  // indicators: true,
  pauseOnHover: false,
  canSwipe: true,
  duration: 3000
};

const SlidesVideos = () => {
  const classes = useStyles();
  const [dimesinoW, setDimensionW] = useState(window.innerWidth);
  const langContext = useContext(AppContext);
  const [titlesLang, setTitlesLang] = useState(0);

  const chooseLang = () => {
    if (chooselll(langContext.engEsp)) {
      setTitlesLang(0);
    
    } else {
      setTitlesLang(1);
    }
  };

  const chooselll = (x) => {
    if (x === "trueee") {
      return true;
    } else if (x === "falseee");
    {
      return false;
    }
  };

  useEffect(() => {
    chooseLang();
  }, [langContext.engEsp]);

  const updateWidthAndHeight = () => {
    setDimensionW(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });

  return (
    <div>

<header
 className="w3-display-container w3-content w3-wide "
  style={{maxWidth: "3000px",}} id="home" >
   
   <div className="slide-container">
      <Fade {...properties}>

  {obj.map(  (item) => {
    return (
      <span>
        <img
          className="slide-container"
          key={item[0]}
          src={item[0]}
          style={{opacity: 1,
          maxHeight: window.innerHeight<1400 ? "90vh": "90vh",
          maxWidth: window.innerWidth<800 ? "100vw": "100vw" 
        
        }}
          />
  
          
            <h1
              style={{
                textAlign: "center",
                position: "absolute",
                top: dimesinoW < 680 ? "40%" : "50%",
                left: "50%",
                fontFamily: "Barlow",
                fontSize: window.innerWidth<1100 ? "4vh" : "10vh",
                color: "white",
                transform: "translate(-50%, -50%)",
                textShadow: "2px 2px 4px black", 
              }}
            >
               <Flip left  >
                   {item[1][titlesLang]}
               </Flip>




{item[2]==="" ? null:  
               <Link href= {item[2]}
              
               >    

            <div>

<div
        
        style={{
          border: "2px solid white",
      backgroundColor: "transparent",
    borderRadius: 12,
    boxShadow: "2px 2px 4px black", 
    // fontSize: "16px",
    width: "auto",
    "&:hover": {
      color: "#8cb1ab",

      textDecoration: "none",
    },
    
  }}
        >


          
       <div
       
      
       style={{
        "&:hover": {
          color: "#8cb1ab",
    
          textDecoration: "none",
        },
        
        fontFamily: "Barlow",
        fontSize: window.innerWidth<1100 ? "2vh" : "5vh",
        color: "white",
   
      }}
       >

         
 {
 
 
 titlesLang===0 ? "Enter" : "Entrar" }
       </div>
     
        </div>
        </div> 
            
          </Link>}

            </h1>
            

          
        </span>
        
    )
  })}
     
  
      </Fade>
      </div>
  

   </header>

   
    </div>
    
  );
}

export default SlidesVideos;